module.exports = __webpack_public_path__ + "images/pages/lp/lens_2_71ede708a648a9c03a20c8fbd411e9ab.png";